import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { routes } from "../routes/routes";
const usePageTracking = () => {
  const location = useLocation();
  // Recursive function to find the route based on path
  const findRoute = (path, routes) => {
    for (let route of routes) {
    //   console.log("route", route);
      if (route.path === path && route.key !== "afterloggedin") {
        return route;
      }
      if (route.children) {
        const childRoute = findRoute(path, route.children);
        if (childRoute) return childRoute;
      }
    }
    return null;
  };

  useEffect(() => {
    // console.log("location.pathname", location);
    // console.log("location.pathname", location.pathname);
    // console.log("routes", routes);
    const currentRoute = findRoute(location.pathname, routes);

    if (currentRoute) {
      const pageTitle = currentRoute.meta?.title || currentRoute.name;
      document.title = pageTitle; // Set the document title

      // Log tracking to Google Analytics
    //   window.gtag("config", "G-4P6HR0M06X", {
    //     page_path: location.pathname,
    //   });
    } else {
      // Default title if route not found
      document.title = "Admin Console";
    }
  }, [location]);
};

export default usePageTracking;
